<template lang="pug">
  div
    div(v-if='!rendered', style='display:none')
      component(id="test",:is='icon',:size='128')
      canvas(:width='iconWidth',:height='iconHeight')
    slot(name='children'
        v-bind:childComponent='childComponent',
        v-bind:parentHolder='holder',
        v-bind:genericParentContainer='innerContainer',
        v-bind:parentContainer='outerContainer')
    slot(v-if='rendered',name='holder',
        v-bind:holder='holder',
        v-bind:transform='transform',
        v-bind:context='context',
        v-bind:depth='depth',
        v-bind:childrenComponent='childComponent',
        v-bind:innerContainer='innerContainer',
        v-bind:outerContainer='outerContainer',
        v-bind:displayObject='sprite.sprite')
    //get-container-bounds(v-if='rendered',:container='innerContainer')
      template(#default="{bounds}")
        overlay.-m-2(:bounds='bounds', @click='lol')
</template>
<script>
import { mapState } from 'vuex';
import getChildComponent from '@edit/tree/funkies.js';
import Overlay from '@edit/atoms/Overlay.vue';
import GetContainerBounds from '@edit/atoms/GetContainerBounds.vue';
import Holder from '@edit/render/holder.js';
import Loader from '@/edit/loader.js';
import EventEmitter from 'eventemitter3';


// Icons
import Camera from '@icons/Camera.vue';
import Alarm from '@icons/Alarm.vue';
import Api from '@icons/Api.vue';
import FormatAlignJustify from '@icons/FormatAlignJustify.vue';
import Grid from '@icons/Grid.vue';
import SelectGroup from '@icons/SelectGroup.vue';
import Dice5 from '@icons/Dice5.vue';
import RadioTower from '@icons/RadioTower.vue';
import ImageMultiple from '@icons/ImageMultiple.vue';
import Firework from '@icons/Firework.vue';
import Repeat from '@icons/Repeat.vue';
import GestureTap from '@icons/GestureTap.vue';
import Filmstrip from '@icons/Filmstrip.vue';
import StateMachine from '@icons/StateMachine.vue';
import Help from '@icons/Help.vue';


export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    innerContainer:{
      type:Object,
      required:true
    },
    outerContainer:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    partutil:{
      type:Object,
      required:true
    },
    depth:{
      type:Number,
      required:true
    },
    holder:{
      type:Object,
      required:true
    },
    context: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    let showLabel = false;
    const component = this.partutil.findComponentForTransform(this.transform);
    let images = {
      camera:'camera-clipart-Free-camera-clipart-free-clipart-graphics-images-and-photos.png',
      delayTransform:'delay.png',
      fetchTransform:'fetch.png',
      forEachTransform:'array.png',
      gridTransform:'grid.png',
      groupTransform:'group.png',
      randomTransform:'random.png',
      onEventTransform:'placeholder.png',
      parallaxTransform:'placeholder.png',
      particleTransform:'particles.png',
      scrollTransform:'state.png',
      spineTransform:'fetch.png',
      stateManager:'state.png'
    }
    let icons = {
      camera:Camera,
      delayTransform:Alarm,
      fetchTransform:Api,
      forEachTransform:FormatAlignJustify,
      gridTransform:Grid,
      groupTransform:SelectGroup,
      randomTransform:Dice5,
      onEventTransform:RadioTower,
      parallaxTransform:ImageMultiple,
      particleTransform:Firework,
      spawner:Repeat,
      scrollTransform:GestureTap,
      spineTransform:Filmstrip,
      stateManager:StateMachine
    }
    let icon = icons[component.type] || Help

    return {
      component,
      showLabel,
      icon,
      rendered: false,
      iconColor: '#ffff00',
      iconWidth: 128,
      iconHeight: 128
    }
  },
  components:{
    Overlay,
    GetContainerBounds
  },
  mounted() {
      const svgEl = this.$el.querySelector('.material-design-icon__svg');
      const lol = svgEl.querySelector('path');
      lol.setAttribute('fill', this.iconColor);
      var svgString = new XMLSerializer().serializeToString(svgEl);
      var canvas = this.$el.querySelector('canvas');
      var ctx = canvas.getContext("2d");
      var DOMURL = window.URL || window.webkitURL || window;
      var img = new Image();
      var svg = new Blob([svgString], {type: "image/svg+xml"});
      var url = DOMURL.createObjectURL(svg);
      img.onload = () => {
          ctx.drawImage(img, 0, 0);
          var png = canvas.toDataURL("image/png");

          this.sprite = new Simple(png, this.renderTools, this.innerContainer, this.transform, this.component, this.iconColor, [this.iconWidth, this.iconHeight], this.isAdvancedMode);
          this.sprite.events.on("loaded", () => {
            this.rendered = true;
            this.$emit("loaded");
          });
          this.renderTools.addToEnterBatch(this.sprite);

          DOMURL.revokeObjectURL(png);
      };
      img.onerror = (err) => {
        console.error('error loading svg', err);
      }
      img.src = url;

  },
  methods:{
  },
  beforeDestroy() {
    if (this.sprite && this.sprite.events) {
      this.sprite.events.off("loaded");
    }
    if (this.sprite && this.sprite.exit) {
      this.renderTools.addToExitBatch(this.sprite);
    }
  },
  computed:{
    childComponent() {
      return getChildComponent(this.component);
    },
    ...mapState(['isAdvancedMode'])
  },
  watch:{
    isAdvancedMode(nv) {
      this.sprite.setIsAdvancedMode(nv);
    }
  }
}

function Simple(img, renderTools, parentContainer, transform, data, iconColor, dims, isAdvancedMode) {
  this.img = PIXI.Texture.from(img);
  this.renderTools = renderTools;
  this.parentContainer = parentContainer;
  this.transform = transform;
  this.data = data;
  this.alpha = 1;
  this.sprite = new PIXI.Sprite();
  this.loading = true;
  this.events = new EventEmitter();

  this.iconColor = iconColor;
  this.iconWidth = dims[0];
  this.iconHeight = dims[1];
  this.isAdvancedMode = isAdvancedMode;
}
Simple.prototype.getUrl = function (img) {
  return this.renderTools.makeImageUrl(img);
}
Simple.prototype.enter = function () {
  const img = this.img
  const x = this.transform.transform.pos.x;
  const y = this.transform.transform.pos.y;
  const rotation = this.transform.transform.rotation;
  const scale = this.transform.transform.scale;

  this.renderTools.addToWaitBatch(this.waiting.bind(this));

  this.myContainer = this.parentContainer;
  //this.myContainer = new PIXI.Container();
  this.myContainer.addChild(this.sprite);


  this.sprite.anchor.set(0.5, 0.5);

  this.rectangle = new PIXI.Graphics();
  this.rectangle.lineStyle(4, this.iconColor.replace('#', '0x'));
  const perc = 1.3;
  this.rectangle.drawRect(perc * -this.iconWidth/2, perc * -this.iconHeight/2, perc * this.iconWidth, perc * this.iconHeight);
  this.rectangle.endFill();
  this.myContainer.addChild(this.rectangle);

  this.setIsAdvancedMode(this.isAdvancedMode);

  this.loadImage();


}

Simple.prototype.setIsAdvancedMode = function (nv) {
  this.isAdvancedMode = nv;
  this.sprite.alpha = nv ? 1 : 0;
  this.rectangle.alpha = nv ? 1 : 0;

  this.renderTools.addToUpdateBatch(this);
}

Simple.prototype.loadImage = function () {
  const texture = this.img;
  const sprite = this.sprite;
  sprite.texture = this.img;
  const textureWidth = this.iconWidth;
  const textureHeight = this.iconHeight;
  const unit = this.renderTools.worldToScreen({x:1, y:1});
  sprite.scale.x = unit.x / textureWidth;
  sprite.scale.y = unit.y / textureHeight;

  this.loading = false;

}

Simple.prototype.waiting = function () {
  if (!this.myContainer) {
    return;
  }
  if (this.destroyed) {
    return;
  }

  if (!this.loading) {
    this.events.emit("loaded");
  } else {
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
  }
}

Simple.prototype.getSquare = function () {
  const x = this.object.transform.scale.x;
  const y = this.object.transform.scale.y;
  return {
    x1:-x/2,
    x2:x/2,
    y1:-y/2,
    y2:y/2
  }
}
Simple.prototype.getScaleThingy = function () {
  return this.object.transform.scale;
}
Simple.prototype.onSelect = function (event) {
  this.events.emit('select-transform', event);
}
Simple.prototype.update = function () {
  if (!this.myContainer || !this.myContainer.position) {
    return;
  }
  this.myContainer.alpha = this.alpha;

  if (this.transform.transform.anchor) {
    const sprite = this.sprite;
    sprite.anchor.set(
      this.transform.transform.anchor.x,
      this.transform.transform.anchor.y,
    )
  }

}

Simple.prototype.exit = function () {
  this.destroyed = true;
  try {
    this.sprite.destroy();
  } catch (e) {
  }
  try {
    this.myContainer.destroy({
      children:true,
    })
  } catch (e) {
  }
  try {
    this.container.removeChild(this.myContainer);
  } catch (e) {
  }
}



</script>
<style>
.icon-svg {
  stroke: blue !important;
  stroke-width:4px !important;
  outline: 3px solid green !important;
}
</style>
